import styled from 'styled-components';

export const NavigationTabContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 76px;

  margin-left: 38px;
  margin-right: 38px;

  @media print {
    display: none;
  }
`;
